import React, { Component } from "react";
import { Link } from "react-router-dom";

import "./header.css";

// the info box is open on the very first visit and closed afterwards; the choice is remembered
const INFO_KEY = "mapart_info_open";
function readInfoOpen() {
  // no stored choice yet = first visit: open
  try {
    const stored = window.localStorage.getItem(INFO_KEY);
    return stored === null ? true : stored === "1";
  } catch (e) {
    return true;
  }
}
function saveInfoOpen(open) {
  try {
    window.localStorage.setItem(INFO_KEY, open ? "1" : "0");
  } catch (e) {
    // storage not available: nothing to remember
  }
}

class Header extends Component {
  state = { infoOpen: readInfoOpen() };

  componentDidMount() {
    // the first visit counts as seen: from the next visit on the box starts closed (unless it is opened again)
    try {
      if (window.localStorage.getItem(INFO_KEY) === null) {
        window.localStorage.setItem(INFO_KEY, "0");
      }
    } catch (e) {
      // storage not available: nothing to remember
    }
  }

  onInfoToggle = (e) => {
    const open = e.target.open;
    if (open !== this.state.infoOpen) {
      this.setState({ infoOpen: open });
      saveInfoOpen(open);
    }
  };

  render() {
    const { getLocaleString } = this.props;
    const { infoOpen } = this.state;
    const faqPath = `/${![undefined, "en"].includes(this.props.countryCode) ? this.props.countryCode + "/" : ""}faq`;
    return (
      <div className="header">
        <h3>
          <Link to={faqPath}>
            <span className="FAQTextButton">{getLocaleString("FAQ/FAQ")}</span>
          </Link>
          <span> | </span>
          <a href="https://youtu.be/j-4RXPkJKU8" target="_blank" rel="noopener noreferrer">
            {getLocaleString("FAQ/VIDEO-TUTORIAL")}
          </a>
        </h3>
        <details className="infoBox" open={infoOpen} onToggle={this.onInfoToggle}>
          <summary>{getLocaleString("HINTS/TITLE")}</summary>
          <p>{getLocaleString("HINTS/TAGLINE")}</p>
          <ul>
            <li>
              <b>{getLocaleString("HINTS/AREA-TITLE")}</b> {getLocaleString("HINTS/AREA-TEXT")}
            </li>
            <li>
              <b>{getLocaleString("HINTS/PLATE-TITLE")}</b> {getLocaleString("HINTS/PLATE-TEXT")}
            </li>
            <li>
              <b>{getLocaleString("HINTS/QUALITY-TITLE")}</b> {getLocaleString("HINTS/QUALITY-TEXT")}
            </li>
            <li>
              <b>{getLocaleString("HINTS/PRESETS-TITLE")}</b> {getLocaleString("HINTS/PRESETS-TEXT")}
            </li>
          </ul>
          <p>
            <b>
              {getLocaleString("FAQ/PLEASE-READ-1")}
              <Link to={faqPath}>
                <span className="FAQTextButton">{getLocaleString("FAQ/FAQ")}</span>
              </Link>
              {getLocaleString("FAQ/PLEASE-READ-2")}
            </b>
          </p>
        </details>
      </div>
    );
  }
}

export default Header;
